import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import {
  Box,
  Dialog, DialogContent, DialogTitle, Typography,
} from '@mui/material';
import { FC } from 'react';

import ChipButton from 'components/ChipButton';

import { POS_USE_TYPE_OPTIONS } from 'constants/options';

interface SaleTypeModalProps {
  open: boolean;
  onClose: () => void;
  onChange: (useType: string) => void;
}
const SaleTypeModal: FC<SaleTypeModalProps> = ({
  open,
  onClose,
  onChange,
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Select Sale Type</DialogTitle>

    <DialogContent>
      <Box py={0}>
        <ChipButton
          height="100%"
          sx={{ mb: 1 }}
          icon={<SelfImprovementIcon className="useType" sx={{ fontSize: '40px' }} />}
          onClick={() => onChange(POS_USE_TYPE_OPTIONS[0].key)}
        >
          <div>
            <Typography fontWeight={700} className="title">
              {POS_USE_TYPE_OPTIONS[0].value.toUpperCase()}
            </Typography>
          </div>
        </ChipButton>

        <ChipButton
          icon={<MedicalServicesOutlinedIcon className="useType" sx={{ fontSize: '40px' }} />}
          height="100%"
          onClick={() => onChange(POS_USE_TYPE_OPTIONS[1].key)}
        >
          <div>
            <Typography fontWeight={700} className="title">
              {POS_USE_TYPE_OPTIONS[1].value.toUpperCase()}
            </Typography>
          </div>
        </ChipButton>
      </Box>
    </DialogContent>
  </Dialog>
);

export default SaleTypeModal;
